<template>
  <div id="constructionManagement1">
    <div class="pages">
      <div class="image-move-wapper">
        <div v-show="!(userType==0)"  class="svg_headers">
          <div class="svg_header_sliders">
            <div class="percent minus">
              <i @click="subtract" class="el-icon-minus"></i>
            </div>
            <div class="percent">
              <el-slider v-model="value2" :show-tooltip="false" :format-tooltip="formatTooltip" :min="10" :max="maxValue" @change="slider(value2)"></el-slider>
            </div>
            <div class="percent plus">
              <i @click="add" class="el-icon-plus"></i>
            </div>
            <div class="percent price">{{value3}}</div>
          </div>

        </div>

        <div class="image-show-boxs" ref="imageShowBox">
            <div :style="'width:'+ boxwidth + 'px;'">
                <div id="svg1" @mousedown="DragContainerMouseDown" :style="'margin-left:' + dragContainer.newPoint.left+'px; margin-top:' + dragContainer.newPoint.top+'px'">
                    <img draggable="true" :src="imgUrl" :style="'width:' + imgWidth + 'px;height:' + imgHeight + 'px;margin-top:' + marginTop + 'px;margin-left:' + marginLeft + 'px;'" class="bgImg" v-show="!deleteDisabled" id="svgImage" @mousewheel="wheel(event)">
                </div>
                <div v-if="customerType">
                  <img @click="rute(items.id)" :src="items.color" v-show="!items.big" @mouseover="hover(items.id)"
                      @mouseout="out(items.id)" v-for="(items, index4) in point" :key="'4-' + index4" :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.custLatitude : items.latitude) * imgWidth - 17) + 'px;top:' + ((items.remark == '0' ? items.custLongitude : items.longitude) * imgHeight - 32) + 'px;'" style="position: absolute;width:34px;height:34px;" class="pointImg">
                  <img @click="rute(items.id)" :src="items.color" v-show="items.big" @mouseover="hover(items.id)"
                      @mouseout="out(items.id)" v-for="(items, index4) in point" :key="'5-' + index4" :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.custLatitude : items.latitude) * imgWidth - 20) + 'px;top:' + ((items.remark == '0' ? items.custLongitude : items.longitude) * imgHeight - 37) + 'px;'" style="position: absolute;width:40px;height:40px;" class="pointImg">     
                </div>
                <div v-else>
                  <div v-show="!items.big"  style="width:160px;position: absolute;text-align: center;font-size:13px;color:#e5e5e5;text-shadow:#198cff 1px 0 0,#198cff 0 1px 0,#198cff -1px 0 0,#198cff 0 -1px 0;" 
                    v-for="(items, index4) in point" 
                    :key="'41-' + index4" 
                    :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 80) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 53) + 'px;'" class="pointImg">{{items.buildingName}}</div>
                  <div v-show="items.big"  style="width:160px;position: absolute;text-align: center;font-size:18px;color:#e5e5e5;text-shadow:#198cff 1px 0 0,#198cff 0 1px 0,#198cff -1px 0 0,#198cff 0 -1px 0;" 
                    v-for="(items, index4) in point" 
                    :key="'412-' + index4" 
                    :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 80) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 58) + 'px;'" class="pointImg">{{items.buildingName}}</div>
                  <img @click="handerFloor('',items)" 
                    :src="items.color" 
                    style="width:34px;height:34px;position: absolute;" 
                    v-for="(items, index4) in point" 
                    :key="'4-' + index4" 
                    :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 17) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 32) + 'px;'" class="pointImg">       
                </div>
            </div>
            <div
                  v-show="items.povperShow"
                  @mouseover="hoverDetail(items.id)"
                  @mouseout="outDetail(items.id)"
                  v-for="(items, index3) in point"
                  :key="'3-' + index3"
                  class="detail"
                  :style="items.showDetailPath"
                >
                <div class="boxItem" :class="{disabled:items.enabled}">
                    <div class="boxIcon">
                      <img v-if="items.type == 1" src="../../assets/img/typeIcon1.png" alt="icon">
                      <img v-else-if="items.type == 2" src="../../assets/img/typeIcon2.png" alt="icon">
                      <img v-else-if="items.type == 3" src="../../assets/img/typeIcon3.png" alt="icon">
                      <img v-else-if="items.type == 4" src="../../assets/img/typeIcon4.png" alt="icon">
                      <img v-else-if="items.type == 5" src="../../assets/img/typeIcon5.png" alt="icon">
                      <img v-else-if="items.type == 6" src="../../assets/img/typeIcon6.png" alt="icon">
                    </div>
                    <div class="boxIconDisable" v-show="items.enabled">
                      <img src="../../assets/img/prohibit.png" alt="icon">
                    </div>
                    <div class="boxText">
                      <div>
                          <el-tooltip class="item" effect="dark" :content="items.monitoringName" placement="bottom-start">
                              <span>{{items.monitoringName}}</span>
                          </el-tooltip>
                      </div>
                      <div>
                          <el-tooltip class="item" effect="dark" :content="items.detailAddress" placement="bottom-start">
                              <span>{{items.detailAddress}}</span>
                          </el-tooltip>
                      </div>
                      <div>
                        <span class="Online" v-if="items.connectStatus == false">在线</span>
                        <span class="Offline" v-else>离线</span>
                        <span class="Online" v-if="items.deviceStatus == 0">启用</span>
                        <span class="fault" v-else>故障</span>
                        <span class="Online" v-if="items.runStatus == 0">正常</span>
                        <span class="Online" v-if="items.runStatus == 1">告警</span>
                        <span class="alarm" v-else>预警</span>
                      </div>
                    </div>
                  </div>                
                </div>
          <!-- 底部渐变背景 -->
          <div class="svg_footer"></div>
        </div>
        <div class="No" v-show="deleteDisabled">
            <img src="../../../static/img/NoUploaded.png">
            <span style="color:#f5f5f5;">尚未上传建筑平面图</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ajaxFuncJson,uploadIp} from '@/api/ajax';
import {mapState,mapGetters,mapActions} from 'vuex'

export default {
  name: "constructionManagement1",
  data() {
    return {
      customerType:'',
      dragContainer: {
        box: {
          w: 0,
          h: 0
        },
        point: {
          left: 0,
          top: 0
        },
        newPoint: {
          left: 0,
          top: 0
        }
      },
      mousePoint: {
        x: 0,
        y: 0
      },
      imageShowBox: {
        box: {
          w: 0,
          h: 0
        },
        dragcheck: {
          h: true,
          v: true
        }
      },
      boxwidth: window.innerWidth,
      boxheight: window.innerHeight,
      value2: 100, // slide默认值 图片原始大小为100/后期修改
      value3: '',
      isDrag: false, //鼠标点击按下判断false按下
      timmerHandle: null, // 定时器
      circleUp: true, // 判断鼠标是否在圆点中点击，组织事件冒泡
      path: [],
      pointIndex: 1, //自定义的point id
      scale: 100, // 保存缩放大小
      event: null,
      viewBoxPath: '0 0 1560 1143',
      maxValue: 100 * Math.pow(1.1,15),
      btnShow: JSON.parse(sessionStorage.getItem('btnShow')),
      userType: sessionStorage.getItem('userType'),
      setPoint: [], // 客户设置点
      floorSetPoint: [], // 楼层设置点
      floorid: '', // 楼层id
      index: null,  // 楼层索引
      screenHeight: window.innerHeight,
      screenWidth: window.innerWidth,
      svgHeaderWidth: window.innerWidth,
      svgHeaderHeight: window.innerHeight,
      marginTop: 0,
      marginLeft: 0,
      lastPoint: {
        x: 0,
        y: 0
      },
      imgWidth: '',
      imgHeight: '',
      setPointLeft: 0, // 初始时左侧导航+padding的和值
      setPointTop: 0   // 初始时图片到窗口顶部的距离
    };
  },
  created() {
    this.$emit('getItem', true); //是否显示左侧新增建筑图标
    this.getpointMap()
  },
  mounted() {
  },
  updated() {
    let _this = this;
    if (_this.$store.state.pointData != null) {
      if(_this.$store.state.pointData.Info){
        _this.$store.state.pointData.Info.map( e => {
          _this.showImg(e)
        if(this.customerType){ //四期区分建筑图标
            if(e.type==1){         //电气
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                  e.color = './static/img/electric/electric_grey.png'
                } else {
                  e.color = './static/img/electric/electric_grey1.gif'
                }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  // 正常
                  if (e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/electric/electric_2.png'   // 黄颜色图片
                    } else {
                      e.color = './static/img/electric/electric_1.gif'  // 黄颜色动图
                    }
                  } else if (e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/electric/electric_red.png'
                    } else {
                      e.color = './static/img/electric/electric_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/electric/electric_green.png'
                    } else {
                      e.color = './static/img/electric/electric_green.png'
                    }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/electric/electric_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/electric/electric_green.png'
                      } else {
                        e.color = './static/img/electric/electric_green.png'
                      }
                    }
                  }
                }
              }
            }else if(e.type==2) {  //水压
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                  e.color = './static/img/pressure/pressure_grey.png'
                } else {
                  e.color = './static/img/pressure/pressure_grey1.gif'
                }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  if(e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/pressure/pressure_2.png'
                    } else {
                      e.color = './static/img/pressure/pressure_1.gif'
                    }
                  } else if (e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/pressure/pressure_red.png'
                    } else {
                      e.color = './static/img/pressure/pressure_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/pressure/pressure_green.png'
                    } else {
                      e.color = './static/img/pressure/pressure_green.png'
                    }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/pressure/pressure_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/pressure/pressure_green.png'
                      } else {
                        e.color = './static/img/pressure/pressure_green.png'
                      }
                    }
                  }
                }
              }
            }else if(e.type==3) {  //液位
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/level/level_grey.png'
                      } else {
                        e.color = './static/img/level/level_grey1.gif'
                      }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  if(e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/level/level_2.png'
                    } else {
                      e.color = './static/img/level/level_1.gif'
                    }
                  } else if (e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/level/level_red.png'
                    } else {
                      e.color = './static/img/level/level_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/level/level_green.png'
                      } else {
                        e.color = './static/img/level/level_green.png'
                      }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/level/level_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/level/level_green.png'
                      } else {
                        e.color = './static/img/level/level_green.png'
                      }
                    }
                  }
                }
              }
            }else if(e.type==4) {  //可燃气
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/gas/gas_grey.png'
                      } else {
                        e.color = './static/img/gas/gas_grey1.gif'
                      }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  if (e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/gas/gas_2.png'
                    } else {
                      e.color = './static/img/gas/gas_1.gif'
                    }
                  } else if(e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/gas/gas_red.png'
                    } else {
                      e.color = './static/img/gas/gas_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/gas/gas_green.png'
                      } else {
                        e.color = './static/img/gas/gas_green.png'
                      }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/gas/gas_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/gas/gas_green.png'
                      } else {
                        e.color = './static/img/gas/gas_green.png'
                      }
                    }
                  }
                }
              }
            }else if(e.type==5) {  //烟感
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/sensation/sensation_grey.png'
                      } else {
                        e.color = './static/img/sensation/sensation_grey1.gif'
                      }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  if (e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/sensation/sensation_2.png'
                    } else {
                      e.color = './static/img/sensation/sensation_1.gif'
                    }
                  } else if (e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/sensation/sensation_red.png'
                    } else {
                      e.color = './static/img/sensation/sensation_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/sensation/sensation_green.png'
                      } else {
                        e.color = './static/img/sensation/sensation_green.png'
                      }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/sensation/sensation_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/sensation/sensation_green.png'
                      } else {
                        e.color = './static/img/sensation/sensation_green.png'
                      }
                    }
                  }
                }
              }
            }else if(e.type==6) {  //灭火器
              if (e.connectStatus) {    //连接为true   正常
                if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/bottle/bottle_grey.png'
                      } else {
                        e.color = './static/img/bottle/bottle_grey1.gif'
                      }
              } else {
                // 在线
                if (e.runStatus) {     //故障
                  if (e.colorType == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/bottle/bottle_2.png'
                    } else {
                      e.color = './static/img/bottle/bottle_1.gif'
                    }
                  } else if (e.colorType == 2) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                      e.color = './static/img/bottle/bottle_red.png'
                    } else {
                      e.color = './static/img/bottle/bottle_red1.gif'
                    }
                  }
                } else {
                  if (e.deviceStatus == 1) {
                    if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/bottle/bottle_green.png'
                      } else {
                        e.color = './static/img/bottle/bottle_green.png'
                      }
                  } else {
                    if (e.lowVoltage) {
                      e.color = './static/img/bottle/bottle_green.png'
                    } else {
                      if (sessionStorage.getItem('menuS2') == e.id) {
                        e.color = './static/img/bottle/bottle_green.png'
                      } else {
                        e.color = './static/img/bottle/bottle_green.png'
                      }
                    }
                  }
                }
              }
            }
        }else { //建筑
           if(e.colorType == 1){ //离线
               e.color = './static/img/lixian.gif'
           }else if(e.colorType == 2){ //告警
               e.color = './static/img/gaojing.gif'
           }else if(e.colorType == 3){ //预警
               e.color = './static/img/yujing.gif'
           }else{//如果状态为4是正常
               e.color = './static/img/zhengchang.png'
           }
        }
        })    
      }
    }
  },
  computed: {
    pointData() {
      return this.$store.state.pointData
    },
    point: {
      get() {
        if (this.$store.state.pointData != null) {
          if(!this.customerType) { //建筑
                if(this.$store.state.pointData.Info){
                  if(this.$store.state.pointData.Info.length>0){
                    this.$store.state.pointData.Info.map( e => {
                      if(e.colorType == 1){ //离线
                          e.color = './static/img/lixian.gif'
                      }else if(e.colorType == 2){ //告警
                          e.color = './static/img/gaojing.gif'
                      }else if(e.colorType == 3){ //预警
                          e.color = './static/img/yujing.gif'
                      }else{//如果状态为4是正常
                          e.color = './static/img/zhengchang.png'
                      }
                    });
                  }
                }
            }
          return this.$store.state.pointData.Info
        }
      },
      set(val) {
        if (this.$store.state.pointData != null) {
          this.$store.state.pointData.Info = val
        }
      },
    },

    floorList: {
      get() {
        return this.$store.state.floorList
      },
      set(val) {
        this.$store.state.floorList = val
      },
    },
    rightList() {
      return this.$store.state.rightList
    },
    imgUrl() {
      var uploadIMG = uploadIp()
      if(this.$store.state.pointData != null && this.$store.state.pointData.PhotoUrl !=0){
        return uploadIMG + '/file/filePreview/' + this.$store.state.pointData.PhotoUrl
      }else{
        return ''
      }
    },
    deleteDisabled() {
      if (this.$store.state.pointData) {
        if(this.$store.state.pointData.PhotoUrl){
          return this.$store.state.pointData.PhotoUrl != '0' ?false : true;
        }else{
          return  true;
        }
      }
    },
  },
  watch: {
    pointData(val) {
      if (val) {
        this.imgWidth = this.boxwidth;
        this.imgHeight = val.high * this.boxwidth/val.width;
        this.dragContainer.newPoint = {
          left:  0,
          top:  this.svgHeaderHeight - this.imgHeight < 0 ? 0 : (this.svgHeaderHeight - this.imgHeight) / 2
        }
        this.value2 = this.imgWidth/val.width * 100
      };
      if(sessionStorage.getItem('buildId') == ''){ //四期区别首页、楼层管理
         this.customerType = false; //客户
      }else{
         this.customerType = true; //建筑
      }
    },
  },
  methods: {
    handerFloor(item,items){
      this.$parent.handerFloor(item,items);
    },
    settingEvent(event){
      event.stopPropagation(); //此区域不受上面方法的影响
    },
    rute(val){
      sessionStorage.setItem('saveId',val); //详情id
      this.$router.push({path:'/content/monitorDetails'})// 进入监控详情页面
    },
    getpointMap() {
      let _this = this;
      if (_this.isAuth('common:interface') && sessionStorage.getItem('remark') == '0') {
        let params = {
          id: sessionStorage.getItem('customerId'),
        }
        // ajaxFuncJson('/building/showBuilding',params).then(res=>{
        //   sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
        //   _this.$store.dispatch('getRightPoint',res.data.data);
        //   _this.imgWidth = _this.boxwidth;
        //   _this.imgHeight = _this.$store.state.pointData.high * _this.boxwidth/_this.$store.state.pointData.width;
        //   _this.dragContainer.newPoint = {
        //     left:  _this.boxwidth - _this.$store.state.pointData.width < 0 ? 0 : (_this.boxwidth - _this.$store.state.pointData.width) / 2,
        //     top:  _this.boxheight - _this.$store.state.pointData.high < 0 ? 0 : (_this.boxheight - _this.$store.state.pointData.high) / 2
        //   }
        //   _this.value2 = _this.imgWidth/_this.$store.state.pointData.width * 100
        // });
      }
    },
    subtract() {
      this.value2 -= 10;
      this.slider(this.value2)
    },
    add() {
      this.value2 += 10;
      this.slider(this.value2)
    },
    formatTooltip(val) {
      this.value3 = parseInt((val/(100 * Math.pow(1.1,15))) * 100 * Math.pow(1.1,15)) + '%'
      return parseInt((val/(100 * Math.pow(1.1,15))) * 100) + '%'
    },
    hoverDetail(id) {
      this.point.map(e => {
        if (e.id == id) {
          e.povperShow = true;
        }
      });
    },
    outDetail(id) {
      this.point.map(e => {
        if (e.id == id) {
          e.povperShow = false;
        }
      });
    },
    slider(e) {
        let _this = this;
        _this.scale = e;
        if(e >= 10) {
            _this.imgWidth = _this.$store.state.pointData.width * (_this.scale/100);
            _this.imgHeight= _this.$store.state.pointData.high * (_this.scale/100);
        }
    },
    // 滑过目标点事件
    hover(e) {
      this.$store.state.pointData.Info.map(k => {
        if (e== k.id) {
          this.$set(k,'big',true)
        }
      });
      let _this = this;
      this.hoverShow=true;
      _this.point.map(i => {
        if (e == i.id) {
          _this.showPovperPath(i)
          i.povperShow = true;
        }
      });
    },
    // 滑出目标点事件
    out(e) {
      this.$store.state.pointData.Info.map(k => {
        if (e== k.id) {
          this.$set(k,'big',false)
        }
      });
      this.point.map(i => {
        if (e == i.id) {
          i.povperShow = false;
        }
      });
    },
    down(event) {
      // 鼠标点击按下事件
      this.isDrag = false;
      this.circleUp = true;
      this.timmerHandle = setTimeout(this.setDragTrue, 200);
    },
    setDragTrue(event) {
      this.isDrag = true;
    },
    showImg(e) {
      if (e.remark == '0') {  // 客户点位
        if (window.innerWidth < 1980 && window.innerWidth > 1288) {
          // 窗口宽度小于1980时
          let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left;
          let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top;
          e.imgShowPath = "left:" + left + "px; top:" + top + "px";
        } else {           /// 后期还是要修改坐标点
          let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 10;
          let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
          e.imgShowPath = "left:" + left + "px; top:" + top + "px";
        }
      } else {
        if (window.innerWidth < 1980 && window.innerWidth > 1288) {
          // 窗口宽度小于1980时
          let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left;
          let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top;
          e.imgShowPath = "left:" + left + "px; top:" + top + "px";
        } else {           /// 后期还是要修改坐标点
          let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 10;
          let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top;
          e.imgShowPath = "left:" + left + "px; top:" + top + "px";
        }
      }  
    },    
    // 显示povper的位置
    showPovperPath(e) {
      if (e.remark == '0') {  // 客户点位 (总览图)
        if (window.innerWidth < 1980 && window.innerWidth >= 1366) {                   
          // 窗口宽度小于1980时
          let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
          let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
          if (left < window.innerWidth + 10 - 366 && top > 120) {
            // 定义povper右上角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 120 - 20) + "px";
          } else if (left < window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 120) {            
            // 定义povper右下角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 120) {            
            // 定义povper左下角显示
            e.showDetailPath =
              "left:" + (left - 366) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top > 120) {
            // 定义povper左上角显示
            e.showDetailPath =
              "left:" + (left - 366) + "px; top:" + (top - 120 - 20) + "px";
          }
        } else {                     /// 后期还是要修改坐标点
          let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
          let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
          if (left < window.innerWidth - 366 && top > 120) {                                            
            // 定义povper右上角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 120 - 20) + "px";
          } else if (left < window.innerWidth - 366 && top < 120) {             
            // 定义povper右下角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth - 366 && top < 118 ) {            
            // 定义povper左下角显示
            e.showDetailPath =
              "left:" + (left - 366 ) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth - 366 && top > 120 ) {
            // 定义povper左上角显示
            e.showDetailPath =
              "left:" + (left - 366) + "px; top:" + (top - 120 - 20) + "px";
          }
        }
      } else { //楼栋        
        if (window.innerWidth < 1980 && window.innerWidth > 1366) {
          // 窗口宽度小于1980时
          let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
          let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
          if (left < window.innerWidth + 10 - 366 && top > 120) {
            // 定义povper右上角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 120 - 20) + "px";
          } else if (left < window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 120) {            
            // 定义povper右下角显示
            e.showDetailPath =
              "left:" + (left) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 120) {            
            // 定义povper左下角显示
            e.showDetailPath =
              "left:" + (left - 366) + "px; top:" + (top - 20) + "px";
          } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top > 120) {
            // 定义povper左上角显示
            e.showDetailPath =
              "left:" + (left - 366) + "px; top:" + (top - 120 - 20) + "px";
          }
        } else { 
                  /// 后期还是要修改坐标点
          let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left;
          let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top;
          if (left < window.innerWidth - 288 && top > 118) {
            // 定义povper右上角显示
            e.showDetailPath =
              "left:" + (left + 20 + 6) + "px; top:" + (top - 118) + "px";
          } else if (left < window.innerWidth - 288 && top < 118) {
            // 定义povper右下角显示
            e.showDetailPath =
              "left:" + (left + 20 + 6) + "px; top:" + (top + 16) + "px";
          } else if (left > window.innerWidth - 288 && top < 118) {
            // 定义povper左下角显示
            e.showDetailPath =
              "left:" + (left - 288 + 14) + "px; top:" + (top + 16) + "px";
          } else if (left > window.innerWidth - 288 && top > 118) {
            // 定义povper左上角显示
            e.showDetailPath =
              "left:" + (left - 288 + 14) + "px; top:" + (top - 118) + "px";
          }
        }
      }
    },
    move() {
      // console.log('拖动事件')
    },
    wheel(event) {
      let svgImage = document.getElementById('svgImage');
      let ev = event || window.event;
      if (ev.deltaY > 0) {
        // 缩小
        if (this.value2 > 10) {
          this.value2 = this.value2/1.1; // slider组件与鼠标滑轮事件wheel相关联
          this.dragContainer.newPoint.left += ev.offsetX - ev.offsetX/1.1;
          this.dragContainer.newPoint.top += ev.offsetY - ev.offsetY/1.1;
          this.slider(this.value2);
        }
      } else {
        if (this.value2 < this.maxValue) {
          this.value2 = this.value2 * 1.1;
          this.dragContainer.newPoint.left -= 0.1 * ev.offsetX;
          this.dragContainer.newPoint.top -= 0.1 * ev.offsetY;
          this.slider(this.value2);
        }
      }
    },
    // 鼠标在拖拽容器中按下时触发
    DragContainerMouseDown(e) {
      const _this = this;
      // 记录鼠标点击时的初始坐标
      this.mousePoint = {
        x: e.clientX,
        y: e.clientY
      };
      _this.dragContainer.point = _this.dragContainer.newPoint;
      document.body.onmousemove = _this.DragContainerMouseMove;
      document.onmouseup = _this.DragContainerMouseUp;
      return false;
    },
    // 容器拖拽时触发
    DragContainerMouseMove(e) {
      const _this = this;
      // 鼠标偏移量 = 初始坐标 - 当前坐标
      let dx = e.clientX - _this.mousePoint.x;
      let dy = e.clientY - _this.mousePoint.y;
      _this.dragContainer.newPoint = {
        left: _this.dragContainer.point.left + dx,
        top: _this.dragContainer.point.top + dy,
      }
      if ( _this.dragContainer.newPoint.left > _this.svgHeaderWidth/2) {
        if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
          _this.dragContainer.newPoint = {
            top: _this.svgHeaderHeight/2,
            left: _this.svgHeaderWidth/2
          };
        } else {
          if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
            _this.dragContainer.newPoint = {
              top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high * _this.scale/100,
              left: _this.svgHeaderWidth/2
            };
          } else {
            _this.dragContainer.newPoint = {
              top: _this.dragContainer.newPoint.top,
              left: _this.svgHeaderWidth/2
            };
          }
        }

      } else {
        if ( _this.dragContainer.newPoint.left < _this.svgHeaderWidth/2 - _this.$store.state.pointData.width * _this.scale/100) {
          if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
            _this.dragContainer.newPoint = {
              top: _this.svgHeaderHeight/2,
              left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
            };
          } else {
            if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
              _this.dragContainer.newPoint = {
                top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100,
                left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
              };
            } else {
              _this.dragContainer.newPoint = {
                top: _this.dragContainer.newPoint.top,
                left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
              };
            }
          }
        } else {
          if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
            _this.dragContainer.newPoint = {
              top: _this.svgHeaderHeight/2,
              left: _this.dragContainer.newPoint.left
            };
          } else {
            if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
              _this.dragContainer.newPoint = {
                top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100,
                left: _this.dragContainer.newPoint.left
              };
            } else {
              _this.dragContainer.newPoint = {
                top: _this.dragContainer.newPoint.top,
                left: _this.dragContainer.newPoint.left
              };
            }
          }
        }
      }
      this.point.map(e => {
        this.showPovperPath(e);
      });
      return false;
    },
    // 移动完成 取消onmousemove和onmouseup事件
    DragContainerMouseUp(e) {
      document.body.onmousemove = null;
      document.onmouseup = null;
    },
    PointMouseDown(e) {
      //阻止事件冒泡
      e.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scope>
@import "@/assets/css/mixin.scss";
#constructionManagement1 {
  height: 100%;
}
.pages {
  background: #102239;
  width: 100%;
  height: 100%;
  position: relative;
}

.image-move-wapper {
  position: absolute;
  background: #fff;
  box-shadow: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
}

.image-show-boxs {
  width: 100%;
  height: 100%;
  cursor: move;
  overflow: hidden;
  position: relative;
  background: #102239;
}

.drag-container {
  position: absolute;
  left: 0;
  top: 0;
  /*禁止元素选中*/
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

.drag-image-box {
  position: relative;
}

.point {
  position: absolute;
  background: red;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}
.img {
  width: 20px;
  height: 20px;
  position: fixed;
}
.circle {
  cursor: pointer;
}
.cir {
  animation: ciranimate 500ms linear infinite;
}
.svg_headers {
  height:56px;
  position: absolute;
  left: 50%;
  margin-left: -250px; 
  z-index: 10;
  bottom: 14px;
}
.svg_headers .el-slider__runway{
  background: #2a2d53;
}
.svg_headers .el-slider__bar{
  background: #284380!important;
}

.svg_headers .el-slider__button{
  border: none;
  width: 12px;
  height: 12px;
  background: #66b3ff!important;
}
.el-slider__runway {
  margin: 26px 0;
}

.svg_header_sliders {
  float: left;
  width: 500px;
  height:56px;
  margin: 0 auto;
}
#constructionManagement1 .svg_header_sliders .percent {
  float: left;
}
.svg_header_sliders .el-icon-minus,.svg_header_sliders .el-icon-plus {
  color: #66b3ff;
}
.svg_header_sliders .el-icon-minus{
  margin-right: 10px;
}
#constructionManagement1 .svg_header_sliders .minus,#constructionManagement1 .svg_header_sliders .plus {
  margin-top: 18px;
  cursor: pointer;
}
#constructionManagement1 .svg_header_sliders .minus{
  position: relative;
  top:0;
}
#constructionManagement1 .svg_header_sliders .plus {  
  margin-left: 10px;
  position: relative;
  top:0;
}
#constructionManagement1 .svg_header_sliders .price {
  position: relative;
  margin-top: 18px;
  width: 20px;
  margin-left: 10px;
  color:#66b3ff;
  top:0;
}
#constructionManagement1 .svg_header_sliders .el-slider {
  line-height:56px;
  width:400px;
}
.svg_header_sliders .el-slider__runway,.el-slider__bar {
  height: 4px;
}
.svg_header_sliders .el-slider__button-wrapper {
  top: -16px;
}
.upload-demo {
  display: inline-block;
  margin-right: 10px;
}
.svg_footer{
  width: 100%;
  height: 100px;
  position:absolute;
  bottom: 0;
  background: -webkit-linear-gradient(top,rgba(16,34,57,0),rgba(16,34,57,1)); /* Safari 5.1 - 6 */
  background: -o-linear-gradient(top,rgba(16,34,57,0),rgba(16,34,57,1)); /* Opera 11.1 - 12*/
  background: -moz-linear-gradient(top,rgba(16,34,57,0),rgba(16,34,57,1)); /* Firefox 3.6 - 15*/
  background: linear-gradient(top,rgba(16,34,57,0),rgba(16,34,57,1)); /* 标准的语法 */    
}

.boxItem{
        float: left;
        width: 100%;
        padding: 20px;
        @include flexible;
        @include alignItems(center);
        box-sizing: border-box;
        @include textOverflow;
        color: #282828;
        .boxIcon{
          position: relative;
          &>img{
            width: 80px;
            height: 80px;
            vertical-align: middle;
          }
        }
        .boxText{
          margin-left: 10px;
          width: calc(100% - 80px );
          &>div{
            @include textOverflow;
            margin-bottom: 13px;
            font-size: $fontSizeOne;
          }
          &>div:nth-child(1){
            font-size: $fontSizeThree;
            line-height: 16px;
          }
          &>div:nth-child(3){
            margin-bottom: 0;
            &>span{
              display: inline-block;
              width: 45px;
              text-align: center;
              line-height: 20px;
              @include borderRadius(22px);
              box-sizing: border-box;
              margin-right: 8px;
              &.Online{
                border: 1px solid #48ff48;
                background-color: #daffda;
              }
              &.Offline{
                border: 1px solid #8e8e8e;
                background-color: #f5f5f5;
              }
              &.fault{
                border: 1px solid #fb8c00;
                background-color: #faefe1;
              }
              &.alarm{
                border: 1px solid #f55353;
                background-color: #f5dcdc;
              }
            }
          }
        }
      }
.detail {
    border: 1px solid #e0e0e0;
    width: 364px;
    height: 120px;
    background: #ffffff;
    position: fixed;
    cursor: default;
  }
  #constructionManagement1 .boxIconDisable {
  width: 28px;
  height: 28px;
  position: absolute;
  left: 72px;
  bottom: 15px;
  img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
.pointImg {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/homeConstruction/index.vue